var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarning2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_warning",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_error-copy-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    fill: "#F3B721",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,21.6 L18,21.6 C17.0064,21.6 16.2,20.7936 16.2,19.8 L16.2,10.8 C16.2,9.8064 17.0064,9 18,9 L18,9 C18.9936,9 19.8,9.8064 19.8,10.8 L19.8,19.8 C19.8,20.7936 18.9936,21.6 18,21.6",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,27 L18,27 C17.0064,27 16.2,26.1936 16.2,25.2 L16.2,25.2 C16.2,24.2064 17.0064,23.4 18,23.4 L18,23.4 C18.9936,23.4 19.8,24.2064 19.8,25.2 L19.8,25.2 C19.8,26.1936 18.9936,27 18,27",
    id: "Fill-3",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning2);
export default __webpack_public_path__ + "static/media/icon_warning_2.6467b439e12a71d20d2dc65b88423d99.svg";
export { ForwardRef as ReactComponent };